import { render, staticRenderFns } from "./GroupBox.vue?vue&type=template&id=32596bc9&"
import script from "./GroupBox.vue?vue&type=script&lang=js&"
export * from "./GroupBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports